// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tron-style Wallet Connected Modal */
.tron-modal-overlay {
  position: fixed;
  top: 0; left: 0; 
  width: 100vw; 
  height: 100vh;
  /* Use dynamic viewport height for mobile browsers (MetaMask, etc.) */
  height: calc(var(--vh, 1vh) * 100);
  background: rgba(0,0,0,0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  /* Enable scrolling on mobile if content overflows */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 20px 0;
}
.tron-modal-glass {
  background: linear-gradient(135deg, rgba(0,255,255,0.12), rgba(153,69,255,0.18));
  border: 3px solid #00ffe7;
  border-radius: 32px;
  box-shadow: 0 0 64px #00ffe7, 0 0 16px #7c3aed;
  backdrop-filter: blur(18px) saturate(1.3);
  padding: 38px 44px 32px 44px;
  min-width: 380px;
  max-width: 440px;
  /* Make modal scrollable on mobile */
  max-height: calc(var(--vh, 1vh) * 90);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: auto;
}
.tron-modal-header {
  text-align: center;
  margin-bottom: 18px;
}
.tron-modal-orb {
  font-size: 56px;
  margin-bottom: 8px;
  text-shadow: 0 0 24px #00ffe7, 0 0 32px #7c3aed;
}
.tron-modal-title {
  color: #00ffe7;
  font-weight: 900;
  font-size: 2.1rem;
  text-shadow: 0 0 8px #00ffe7, 0 0 16px #7c3aed;
  margin-bottom: 6px;
}
.tron-modal-desc {
  color: #eaeaf2;
  font-size: 1.1rem;
  margin-bottom: 10px;
}
.tron-modal-stats {
  display: flex;
  gap: 18px;
  margin: 18px 0 18px 0;
  justify-content: center;
}
.tron-modal-stat {
  background: rgba(0,255,255,0.08);
  border-radius: 18px;
  padding: 14px 18px;
  box-shadow: 0 0 12px #00ffe744;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}
.tron-label {
  color: #7c3aed;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 4px;
}
.tron-value {
  color: #00ffe7;
  font-size: 1.3rem;
  font-weight: 900;
  text-shadow: 0 0 8px #00ffe7, 0 0 16px #7c3aed;
}
.tron-modal-actions {
  display: flex;
  gap: 18px;
  margin-top: 18px;
  justify-content: center;
}
.tron-btn {
  padding: 12px 28px;
  border-radius: 16px;
  border: 2px solid #00ffe7;
  background: linear-gradient(135deg, rgba(0,255,255,0.18), rgba(153,69,255,0.18));
  color: #00ffe7;
  font-weight: 900;
  font-size: 1.1rem;
  cursor: pointer;
  box-shadow: 0 0 16px #00ffe744, 0 0 8px #7c3aed44;
  transition: box-shadow 0.2s, background 0.2s, color 0.2s;
}
.tron-btn.neon {
  background: linear-gradient(135deg, #00ffe7 0%, #7c3aed 100%);
  color: #fff;
  text-shadow: 0 0 12px #00ffe7, 0 0 24px #7c3aed;
  border-color: #7c3aed;
}
.tron-btn:hover {
  box-shadow: 0 0 32px #00ffe7, 0 0 16px #7c3aed;
  background: linear-gradient(135deg, #7c3aed 0%, #00ffe7 100%);
  color: #fff;
}
/* BragaBJJ Disk Menu — Desktop Only, Tron Style */
.core3d-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #111;
}
/* Disk menu hologram pop/vanish, transparent style, hover glow */
.core3d-disk {
  width: 924px;
  height: 924px;
  border-radius: 50%;
  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.18) 0%, rgba(34,34,34,0.85) 100%);
  border: 4px solid rgba(0,255,247,0.7);
  box-shadow: 0 0 80px 24px rgba(0,255,247,0.13), 0 0 0 8px #fff1, 0 0 0 2px #fff2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 0.3s, transform 0.2s, background 0.3s, border-color 0.3s;
  position: relative;
  z-index: 2;
  opacity: 0.92;
  backdrop-filter: blur(8px) brightness(1.2);
}
.core3d-disk.open {
  box-shadow: 0 0 120px 40px rgba(0,255,247,0.18), 0 0 0 12px #fff2, 0 0 0 2px #fff3;
  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.28) 0%, rgba(34,34,34,0.95) 100%);
  border-color: #00fff7;
  opacity: 1;
}
.core3d-disk:hover {
  box-shadow: 0 0 100px 32px #00fff7, 0 0 0 8px #fff2, 0 0 0 2px #fff3;
  border-color: #00fff7;
  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.32) 0%, rgba(34,34,34,1) 100%);
  opacity: 1;
}
@keyframes tronPulse {
  0% {
    box-shadow: 0 0 120px 40px #00fff7, 0 0 0 12px #fff2, 0 0 0 2px #fff4;
    border-color: #00fff7;
  }
  100% {
    box-shadow: 0 0 180px 80px #00fff7, 0 0 0 24px #fff2, 0 0 0 4px #fff4;
    border-color: #00eaff;
  }
}
.core3d-logo {
  font-size: 180px;
  font-weight: 900;
  color: #00fff7;
  text-shadow: 0 0 64px #00fff7, 0 0 8px #fff;
  letter-spacing: 0.12em;
  animation: none;
}
.core3d-logo-big {
  font-size: 180px;
}
.core3d-logo-pulse {
  animation: core3dPulse 1.2s infinite alternate cubic-bezier(.4,0,.2,1);
}
@keyframes core3dPulse {
  0% {
    transform: scale(1);
    text-shadow: 0 0 64px #00fff7, 0 0 8px #fff;
    filter: brightness(1.1);
  }
  100% {
    transform: scale(1.18);
    text-shadow: 0 0 128px #00fff7, 0 0 24px #fff;
    filter: brightness(1.3);
  }
}
.core3d-bg-water {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  height: 1200px;
  z-index: 1;
  pointer-events: none;
  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.12) 0%, rgba(34,34,34,0.85) 100%);
  opacity: 0.7;
  border-radius: 50%;
  animation: waterDropAnim 2.8s infinite linear;
}
@keyframes waterDropAnim {
  0% {
    box-shadow: 0 0 80px 20px #00fff7, 0 0 0 8px #fff2;
    filter: blur(0px) brightness(1.1);
  }
  50% {
    box-shadow: 0 0 160px 40px #00fff7, 0 0 0 16px #fff2;
    filter: blur(2px) brightness(1.2);
  }
  100% {
    box-shadow: 0 0 80px 20px #00fff7, 0 0 0 8px #fff2;
    filter: blur(0px) brightness(1.1);
  }
}
.core3d-champion {
  font-size: 1.6rem;
  color: #ffd700;
  font-weight: 700;
  margin-top: 10px;
  text-shadow: 0 0 18px #ffd700, 0 0 8px #fff;
  letter-spacing: 1.5px;
  text-align: center;
}
.core3d-title {
  font-size: 38px;
  font-weight: 700;
  color: #fff;
  margin-top: 12px;
  letter-spacing: 2px;
  text-shadow: 0 0 24px #00fff7;
}
.core3d-motto {
  font-size: 18px;
  color: #00fff7;
  margin-top: 8px;
  font-weight: 500;
  text-shadow: 0 0 12px #00fff7;
}
/* Disk menu ring and options: transparent hologram style */
.core3d-ring {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px; height: 1200px;
  pointer-events: auto;
  z-index: 3;
}
/* Positioning shell — inline style sets the radial transform, never override here */
.core3d-item {
  position: absolute;
  left: 50%; top: 50%;
  transform-origin: center center;
  width: 160px;
  height: 160px;
  cursor: pointer;
}

/* Visual layer — scale/glow here so the radial position is never disturbed */
.core3d-item-inner {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0,255,247,0.18) 0%, rgba(99,102,241,0.22) 100%);
  border-radius: 18px;
  box-shadow: 0 6px 36px rgba(0,255,247,0.14);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.96;
  border: 2px solid rgba(255,255,255,0.14);
  backdrop-filter: blur(8px) brightness(1.05);
  transition: box-shadow 0.25s, transform 0.25s, background 0.25s, border-color 0.25s, opacity 0.25s;
}
.core3d-item:hover .core3d-item-inner {
  box-shadow: 0 8px 48px #00fff7dd, 0 0 0 2px #fff6;
  background: linear-gradient(135deg, rgba(0,255,247,0.36) 0%, rgba(99,102,241,0.36) 100%);
  border-color: #00fff7;
  transform: scale(1.06);
  opacity: 1;
}

.core3d-icon {
  font-size: 56px;
  margin-bottom: 10px;
  pointer-events: none;
}
.core3d-label {
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  pointer-events: none;
}
.core3d-desc {
  font-size: 14px;
  color: #00fff7;
  margin-top: 6px;
  text-align: center;
  opacity: 0.95;
  pointer-events: none;
}

/* ── Responsive scaling ─────────────────────────────────────────────── */
@media (max-width: 1400px) {
  .core3d-disk { width: 720px; height: 720px; }
  .core3d-ring { width: 960px; height: 960px; }
  .core3d-item { width: 130px; height: 130px; }
  .core3d-logo { font-size: 140px; }
  .core3d-logo-big { font-size: 140px; }
  .core3d-title { font-size: 30px; }
  .core3d-motto { font-size: 15px; }
  .core3d-champion { font-size: 1.3rem; }
  .core3d-icon { font-size: 44px; }
  .core3d-label { font-size: 16px; }
  .core3d-desc { font-size: 12px; }
  .core3d-bg-water { width: 950px; height: 950px; }
}
@media (max-width: 1100px) {
  .core3d-disk { width: 560px; height: 560px; }
  .core3d-ring { width: 780px; height: 780px; }
  .core3d-item { width: 110px; height: 110px; }
  .core3d-logo { font-size: 110px; }
  .core3d-logo-big { font-size: 110px; }
  .core3d-title { font-size: 24px; }
  .core3d-motto { font-size: 13px; }
  .core3d-champion { font-size: 1.1rem; }
  .core3d-icon { font-size: 36px; }
  .core3d-label { font-size: 13px; }
  .core3d-desc { font-size: 11px; }
  .core3d-bg-water { width: 750px; height: 750px; }
}
@media (max-width: 900px) {
  .core3d-disk { width: 440px; height: 440px; }
  .core3d-ring { width: 640px; height: 640px; }
  .core3d-item { width: 90px; height: 90px; }
  .core3d-logo { font-size: 88px; }
  .core3d-logo-big { font-size: 88px; }
  .core3d-title { font-size: 20px; }
  .core3d-motto { font-size: 12px; }
  .core3d-champion { font-size: 1rem; }
  .core3d-icon { font-size: 28px; }
  .core3d-label { font-size: 11px; }
  .core3d-desc { display: none; }
  .core3d-bg-water { width: 600px; height: 600px; }
}

`, "",{"version":3,"sources":["webpack://./src/components/coremenudisk3d_v2.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,YAAY;EACZ,aAAa;EACb,qEAAqE;EACrE,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oDAAoD;EACpD,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,gFAAgF;EAChF,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,yCAAyC;EACzC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gFAAgF;EAChF,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iDAAiD;EACjD,wDAAwD;AAC1D;AACA;EACE,6DAA6D;EAC7D,WAAW;EACX,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,8CAA8C;EAC9C,6DAA6D;EAC7D,WAAW;AACb;AACA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,iEAAiE;AACjE;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iGAAiG;EACjG,qCAAqC;EACrC,gFAAgF;EAChF,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+EAA+E;EAC/E,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,kFAAkF;EAClF,iGAAiG;EACjG,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,oEAAoE;EACpE,qBAAqB;EACrB,8FAA8F;EAC9F,UAAU;AACZ;AACA;EACE;IACE,qEAAqE;IACrE,qBAAqB;EACvB;EACA;IACE,qEAAqE;IACrE,qBAAqB;EACvB;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sEAAsE;AACxE;AACA;EACE;IACE,mBAAmB;IACnB,2CAA2C;IAC3C,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,6CAA6C;IAC7C,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iGAAiG;EACjG,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE;IACE,kDAAkD;IAClD,iCAAiC;EACnC;EACA;IACE,oDAAoD;IACpD,iCAAiC;EACnC;EACA;IACE,kDAAkD;IAClD,iCAAiC;EACnC;AACF;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,aAAa,EAAE,cAAc;EAC7B,oBAAoB;EACpB,UAAU;AACZ;AACA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,SAAS,EAAE,QAAQ;EACnB,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ,wFAAwF;EACxF,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;EACxC,2CAA2C;EAC3C,kGAAkG;AACpG;AACA;EACE,iDAAiD;EACjD,wFAAwF;EACxF,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;EACE,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,gBAAgB,EAAE;EACjC,mBAAmB,gBAAgB,EAAE;EACrC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,mBAAmB,iBAAiB,EAAE;EACtC,eAAe,eAAe,EAAE;EAChC,gBAAgB,eAAe,EAAE;EACjC,eAAe,eAAe,EAAE;EAChC,mBAAmB,YAAY,EAAE,aAAa,EAAE;AAClD;AACA;EACE,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,gBAAgB,EAAE;EACjC,mBAAmB,gBAAgB,EAAE;EACrC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,mBAAmB,iBAAiB,EAAE;EACtC,eAAe,eAAe,EAAE;EAChC,gBAAgB,eAAe,EAAE;EACjC,eAAe,eAAe,EAAE;EAChC,mBAAmB,YAAY,EAAE,aAAa,EAAE;AAClD;AACA;EACE,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,eAAe,WAAW,EAAE,YAAY,EAAE;EAC1C,eAAe,eAAe,EAAE;EAChC,mBAAmB,eAAe,EAAE;EACpC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,mBAAmB,eAAe,EAAE;EACpC,eAAe,eAAe,EAAE;EAChC,gBAAgB,eAAe,EAAE;EACjC,eAAe,aAAa,EAAE;EAC9B,mBAAmB,YAAY,EAAE,aAAa,EAAE;AAClD","sourcesContent":["/* Tron-style Wallet Connected Modal */\n.tron-modal-overlay {\n  position: fixed;\n  top: 0; left: 0; \n  width: 100vw; \n  height: 100vh;\n  /* Use dynamic viewport height for mobile browsers (MetaMask, etc.) */\n  height: calc(var(--vh, 1vh) * 100);\n  background: rgba(0,0,0,0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  /* Enable scrolling on mobile if content overflows */\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 20px 0;\n}\n.tron-modal-glass {\n  background: linear-gradient(135deg, rgba(0,255,255,0.12), rgba(153,69,255,0.18));\n  border: 3px solid #00ffe7;\n  border-radius: 32px;\n  box-shadow: 0 0 64px #00ffe7, 0 0 16px #7c3aed;\n  backdrop-filter: blur(18px) saturate(1.3);\n  padding: 38px 44px 32px 44px;\n  min-width: 380px;\n  max-width: 440px;\n  /* Make modal scrollable on mobile */\n  max-height: calc(var(--vh, 1vh) * 90);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  margin: auto;\n}\n.tron-modal-header {\n  text-align: center;\n  margin-bottom: 18px;\n}\n.tron-modal-orb {\n  font-size: 56px;\n  margin-bottom: 8px;\n  text-shadow: 0 0 24px #00ffe7, 0 0 32px #7c3aed;\n}\n.tron-modal-title {\n  color: #00ffe7;\n  font-weight: 900;\n  font-size: 2.1rem;\n  text-shadow: 0 0 8px #00ffe7, 0 0 16px #7c3aed;\n  margin-bottom: 6px;\n}\n.tron-modal-desc {\n  color: #eaeaf2;\n  font-size: 1.1rem;\n  margin-bottom: 10px;\n}\n.tron-modal-stats {\n  display: flex;\n  gap: 18px;\n  margin: 18px 0 18px 0;\n  justify-content: center;\n}\n.tron-modal-stat {\n  background: rgba(0,255,255,0.08);\n  border-radius: 18px;\n  padding: 14px 18px;\n  box-shadow: 0 0 12px #00ffe744;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 80px;\n}\n.tron-label {\n  color: #7c3aed;\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n.tron-value {\n  color: #00ffe7;\n  font-size: 1.3rem;\n  font-weight: 900;\n  text-shadow: 0 0 8px #00ffe7, 0 0 16px #7c3aed;\n}\n.tron-modal-actions {\n  display: flex;\n  gap: 18px;\n  margin-top: 18px;\n  justify-content: center;\n}\n.tron-btn {\n  padding: 12px 28px;\n  border-radius: 16px;\n  border: 2px solid #00ffe7;\n  background: linear-gradient(135deg, rgba(0,255,255,0.18), rgba(153,69,255,0.18));\n  color: #00ffe7;\n  font-weight: 900;\n  font-size: 1.1rem;\n  cursor: pointer;\n  box-shadow: 0 0 16px #00ffe744, 0 0 8px #7c3aed44;\n  transition: box-shadow 0.2s, background 0.2s, color 0.2s;\n}\n.tron-btn.neon {\n  background: linear-gradient(135deg, #00ffe7 0%, #7c3aed 100%);\n  color: #fff;\n  text-shadow: 0 0 12px #00ffe7, 0 0 24px #7c3aed;\n  border-color: #7c3aed;\n}\n.tron-btn:hover {\n  box-shadow: 0 0 32px #00ffe7, 0 0 16px #7c3aed;\n  background: linear-gradient(135deg, #7c3aed 0%, #00ffe7 100%);\n  color: #fff;\n}\n/* BragaBJJ Disk Menu — Desktop Only, Tron Style */\n.core3d-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #111;\n}\n/* Disk menu hologram pop/vanish, transparent style, hover glow */\n.core3d-disk {\n  width: 924px;\n  height: 924px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.18) 0%, rgba(34,34,34,0.85) 100%);\n  border: 4px solid rgba(0,255,247,0.7);\n  box-shadow: 0 0 80px 24px rgba(0,255,247,0.13), 0 0 0 8px #fff1, 0 0 0 2px #fff2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: box-shadow 0.3s, transform 0.2s, background 0.3s, border-color 0.3s;\n  position: relative;\n  z-index: 2;\n  opacity: 0.92;\n  backdrop-filter: blur(8px) brightness(1.2);\n}\n.core3d-disk.open {\n  box-shadow: 0 0 120px 40px rgba(0,255,247,0.18), 0 0 0 12px #fff2, 0 0 0 2px #fff3;\n  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.28) 0%, rgba(34,34,34,0.95) 100%);\n  border-color: #00fff7;\n  opacity: 1;\n}\n.core3d-disk:hover {\n  box-shadow: 0 0 100px 32px #00fff7, 0 0 0 8px #fff2, 0 0 0 2px #fff3;\n  border-color: #00fff7;\n  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.32) 0%, rgba(34,34,34,1) 100%);\n  opacity: 1;\n}\n@keyframes tronPulse {\n  0% {\n    box-shadow: 0 0 120px 40px #00fff7, 0 0 0 12px #fff2, 0 0 0 2px #fff4;\n    border-color: #00fff7;\n  }\n  100% {\n    box-shadow: 0 0 180px 80px #00fff7, 0 0 0 24px #fff2, 0 0 0 4px #fff4;\n    border-color: #00eaff;\n  }\n}\n.core3d-logo {\n  font-size: 180px;\n  font-weight: 900;\n  color: #00fff7;\n  text-shadow: 0 0 64px #00fff7, 0 0 8px #fff;\n  letter-spacing: 0.12em;\n  animation: none;\n}\n.core3d-logo-big {\n  font-size: 180px;\n}\n.core3d-logo-pulse {\n  animation: core3dPulse 1.2s infinite alternate cubic-bezier(.4,0,.2,1);\n}\n@keyframes core3dPulse {\n  0% {\n    transform: scale(1);\n    text-shadow: 0 0 64px #00fff7, 0 0 8px #fff;\n    filter: brightness(1.1);\n  }\n  100% {\n    transform: scale(1.18);\n    text-shadow: 0 0 128px #00fff7, 0 0 24px #fff;\n    filter: brightness(1.3);\n  }\n}\n.core3d-bg-water {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 1200px;\n  height: 1200px;\n  z-index: 1;\n  pointer-events: none;\n  background: radial-gradient(circle at 60% 40%, rgba(0,255,247,0.12) 0%, rgba(34,34,34,0.85) 100%);\n  opacity: 0.7;\n  border-radius: 50%;\n  animation: waterDropAnim 2.8s infinite linear;\n}\n@keyframes waterDropAnim {\n  0% {\n    box-shadow: 0 0 80px 20px #00fff7, 0 0 0 8px #fff2;\n    filter: blur(0px) brightness(1.1);\n  }\n  50% {\n    box-shadow: 0 0 160px 40px #00fff7, 0 0 0 16px #fff2;\n    filter: blur(2px) brightness(1.2);\n  }\n  100% {\n    box-shadow: 0 0 80px 20px #00fff7, 0 0 0 8px #fff2;\n    filter: blur(0px) brightness(1.1);\n  }\n}\n.core3d-champion {\n  font-size: 1.6rem;\n  color: #ffd700;\n  font-weight: 700;\n  margin-top: 10px;\n  text-shadow: 0 0 18px #ffd700, 0 0 8px #fff;\n  letter-spacing: 1.5px;\n  text-align: center;\n}\n.core3d-title {\n  font-size: 38px;\n  font-weight: 700;\n  color: #fff;\n  margin-top: 12px;\n  letter-spacing: 2px;\n  text-shadow: 0 0 24px #00fff7;\n}\n.core3d-motto {\n  font-size: 18px;\n  color: #00fff7;\n  margin-top: 8px;\n  font-weight: 500;\n  text-shadow: 0 0 12px #00fff7;\n}\n/* Disk menu ring and options: transparent hologram style */\n.core3d-ring {\n  position: absolute;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%);\n  width: 1200px; height: 1200px;\n  pointer-events: auto;\n  z-index: 3;\n}\n/* Positioning shell — inline style sets the radial transform, never override here */\n.core3d-item {\n  position: absolute;\n  left: 50%; top: 50%;\n  transform-origin: center center;\n  width: 160px;\n  height: 160px;\n  cursor: pointer;\n}\n\n/* Visual layer — scale/glow here so the radial position is never disturbed */\n.core3d-item-inner {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(0,255,247,0.18) 0%, rgba(99,102,241,0.22) 100%);\n  border-radius: 18px;\n  box-shadow: 0 6px 36px rgba(0,255,247,0.14);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.96;\n  border: 2px solid rgba(255,255,255,0.14);\n  backdrop-filter: blur(8px) brightness(1.05);\n  transition: box-shadow 0.25s, transform 0.25s, background 0.25s, border-color 0.25s, opacity 0.25s;\n}\n.core3d-item:hover .core3d-item-inner {\n  box-shadow: 0 8px 48px #00fff7dd, 0 0 0 2px #fff6;\n  background: linear-gradient(135deg, rgba(0,255,247,0.36) 0%, rgba(99,102,241,0.36) 100%);\n  border-color: #00fff7;\n  transform: scale(1.06);\n  opacity: 1;\n}\n\n.core3d-icon {\n  font-size: 56px;\n  margin-bottom: 10px;\n  pointer-events: none;\n}\n.core3d-label {\n  font-size: 20px;\n  font-weight: 800;\n  color: #fff;\n  pointer-events: none;\n}\n.core3d-desc {\n  font-size: 14px;\n  color: #00fff7;\n  margin-top: 6px;\n  text-align: center;\n  opacity: 0.95;\n  pointer-events: none;\n}\n\n/* ── Responsive scaling ─────────────────────────────────────────────── */\n@media (max-width: 1400px) {\n  .core3d-disk { width: 720px; height: 720px; }\n  .core3d-ring { width: 960px; height: 960px; }\n  .core3d-item { width: 130px; height: 130px; }\n  .core3d-logo { font-size: 140px; }\n  .core3d-logo-big { font-size: 140px; }\n  .core3d-title { font-size: 30px; }\n  .core3d-motto { font-size: 15px; }\n  .core3d-champion { font-size: 1.3rem; }\n  .core3d-icon { font-size: 44px; }\n  .core3d-label { font-size: 16px; }\n  .core3d-desc { font-size: 12px; }\n  .core3d-bg-water { width: 950px; height: 950px; }\n}\n@media (max-width: 1100px) {\n  .core3d-disk { width: 560px; height: 560px; }\n  .core3d-ring { width: 780px; height: 780px; }\n  .core3d-item { width: 110px; height: 110px; }\n  .core3d-logo { font-size: 110px; }\n  .core3d-logo-big { font-size: 110px; }\n  .core3d-title { font-size: 24px; }\n  .core3d-motto { font-size: 13px; }\n  .core3d-champion { font-size: 1.1rem; }\n  .core3d-icon { font-size: 36px; }\n  .core3d-label { font-size: 13px; }\n  .core3d-desc { font-size: 11px; }\n  .core3d-bg-water { width: 750px; height: 750px; }\n}\n@media (max-width: 900px) {\n  .core3d-disk { width: 440px; height: 440px; }\n  .core3d-ring { width: 640px; height: 640px; }\n  .core3d-item { width: 90px; height: 90px; }\n  .core3d-logo { font-size: 88px; }\n  .core3d-logo-big { font-size: 88px; }\n  .core3d-title { font-size: 20px; }\n  .core3d-motto { font-size: 12px; }\n  .core3d-champion { font-size: 1rem; }\n  .core3d-icon { font-size: 28px; }\n  .core3d-label { font-size: 11px; }\n  .core3d-desc { display: none; }\n  .core3d-bg-water { width: 600px; height: 600px; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
